import { Component, Prop, h, Event, EventEmitter, State } from '@stencil/core';

@Component({
  tag: 'qumra-image-input',
  styleUrl: 'qumra-image-input.css', 
  shadow: false,
  formAssociated: true
})
export class QumraImageInput {

  @Event() optionChange: EventEmitter<any>;

  @Prop() data: string; 
  @Prop() selected: string; 

  @State() properties: any;
  @State() selectedValue: string;

  componentWillLoad() {
    this.properties = JSON.parse(this.data);
    this.selectedValue = this.selected;
  }
  handleOptionClick(value: string) {
    this.selectedValue = value;
    this.properties = { ...this.properties }; 
  
    this.optionChange.emit({ property: this.properties.id, value: this.selectedValue });
  }
  

  render() {
    return (
      <div class="qumra-option-img-container">
        {this.properties.values.map((property: { id: string; value: string }) => (
          <div
          style={{ 
            backgroundColor: this.selectedValue === property.id ? '#d1d5db ' : ''
          }}
            onClick={() => this.handleOptionClick(property.id)}
          >
              <input
              type="radio"
              id={`image-${property.id}`}
              name={`property[${this.properties.id}]`}
              value={property.id}
              style={{ display: 'none' }}
              onChange={() => this.handleOptionClick(property.id)}
              checked={this.selectedValue === property.id}
            />
            <img src={property?.value} alt={property.id}/>
          </div>
        ))}
      </div>
    );
  }
}
